import type { PaginationProps } from 'antd';
import { Pagination } from 'antd';
import "./index.less";
interface IProps {
    currentPage: number,
    onChange: (pageNum: number) => void,
    pageSize?: number,
    total: number,
    showTotal?: boolean,
    totalPage?: number,
    showQuickJumper?: boolean,
    className?: string,
    showSizeChanger?: boolean,
    pageSizeOptions?: number[]
}

export function MythPagination({ currentPage, pageSize, onChange, total, totalPage, showTotal, pageSizeOptions, showSizeChanger, showQuickJumper }: IProps) {
    const changePage: PaginationProps['onChange'] = (pageNumber) => {
        onChange(pageNumber)
    };
    if (total > 0) {
        return <Pagination
            className="myth-pagination text-center"
            pageSize={pageSize ? pageSize : 20}
            // pageSizeOptions={pageSizeOptions||[10,20,30]}
            total={total}
            showTotal={total => showTotal ? `total ${totalPage || (Math.ceil(total / (pageSize || 10)))} pages` : ""}
            current={currentPage}
            showQuickJumper={showQuickJumper || true}
            onChange={changePage}
            showSizeChanger={false}
        />
    }
    else {
        return <></>
    }

}
